import { render } from "./BoxSelection.vue?vue&type=template&id=a0b37b56"
import script from "./BoxSelection.vue?vue&type=script&lang=js"
export * from "./BoxSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__